import { z } from 'zod';

export const fundsResDto = z.object({
  funds: z.number(),
});

export type FundsResDto = z.infer<typeof fundsResDto>;
